import { createAction } from '@ngrx/store';

export class SongPhaseActions {
	public static preloadSongs = createAction('[SongPhase] Preload Songs');
	public static finish = createAction('[SongPhase] Finish');
}
